import React, { useState, useEffect } from "react";
import { MessageFactory } from "../../../lib/messages";
import { Protocol } from "../../../lib/constants";
import { ReactComponent as CloseSVG } from "../../../assets/close.svg";
import DetailedDescription from "./ProvFairDescription";
import {
  OPContainer,
  OPBox,
  OPHeader,
  OPWrapper,
} from "../settings/SettingsStyled";
import { Title, Button, SeedInput, Description } from "./ProvFairStyled";
import useProvablyContent from "./ProvablyContent";
export default ({
  pf,
  Globals,
  handleNotification,
  handleAbove,
  gameIsOn,
  aboveAnim,
  handleAboveAnimation,
  audio,
}) => {
  const [inputSeed, setinputSeed] = useState("");
  const [btnAnimation, setBtnAnimation] = useState(false);
  const [seedError, setSeedError] = useState(false);
  const [soundPlayed, setSoundPlayed] = useState(false);

  // get seeds when component renders
  useEffect(() => {
    Globals.WS.sendMessage(MessageFactory.createMessage(Protocol.GET_SEEDS));
  }, [Globals.WS]);

  //get Provably fair content from useProvablyContent
  const {
    CurrentSeedPair,
    PreviousSeedPair,
    ProvFairTitle,
    ProvFairText,
  } = useProvablyContent(pf);

  // input validation on change
  const changeHandler = (e) => {
    let val = e.target.value;
    const onlyLatinCharsAndNumbers = /^[A-Za-z0-9]+$/;
    if (onlyLatinCharsAndNumbers.test(val) || val === "") {
      setinputSeed(val);
    }
    if (val.length >= 16 && val.length <= 128) {
      setSeedError(false);
      handleNotification(false);
    }
  };


  //request new seed pair
  const submit = () => {
    if (inputSeed.length >= 16 && inputSeed.length <= 128) {
      audio.setSeed();
      handleNotification(false);
      setSeedError(false)
      setinputSeed("");
      Globals.WS.sendMessage(
        MessageFactory.createMessage(Protocol.SET_SEED, inputSeed)
      );
    } else {
      setSeedError(true);
      handleNotification(
        "Length of the seed must be minimum 16  and maximum 128 symbols"
      );
    }
  };

  //handle close button
  const handleClose = () => {
    setBtnAnimation("close");
    audio.goBack();
    setSoundPlayed(true);
    setTimeout(() => {
      handleAboveAnimation(false);
      setTimeout(() => {
        handleAbove(false);
      }, 400);
    }, 150);
  };

  //  copy to clipboard
  const copyToClipboard = (e) => {
    e.target.select();
    document.execCommand("copy");
    handleNotification("Copied to clipboard");
  };

  const VfCheck = () => {
    window.open('https://codepen.io/orbitalgaming/pen/yLwJPyy', '_blank')
  }

  return (
    <OPContainer aboveAnim={aboveAnim} className="prov">
      <OPWrapper>
        <OPBox aboveAnim={aboveAnim}>
          <OPHeader
            close={btnAnimation === "close"}
            aboveAnim={aboveAnim}
            soundPlayed={soundPlayed}
          >
            <p>Prov. Fair</p>
            <span
              onAnimationEnd={() => setBtnAnimation(false)}
              onClick={() => handleClose()}
            >
              <CloseSVG />
            </span>
          </OPHeader>
          {CurrentSeedPair.map((item, id) => (
            <Title key={id} copyCursor={item.Value === ""}>
              <h4>{item.Title}</h4>
              <textarea
                onClick={(e) => item.Value !== "" && copyToClipboard(e)}
                value={item.Value !== "" ? item.Value : item.Placeholder}
                spellCheck="false"
                readOnly="readOnly"
                className={item.Title === "Nonce" ? "nonce" : ""}
              />
            </Title>
          ))}
          <form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
            }}
            onClick={() =>
              gameIsOn &&
              handleNotification("You can't change the seed while round is active")
            }
          >
            <SeedInput
              name="input"
              placeholder="New seed"
              spellCheck="false"
              onChange={changeHandler}
              value={inputSeed}
              notify={seedError}
              clickable={gameIsOn}
            />
            <Button
              prov={btnAnimation === "submit"}
              onAnimationEnd={() => setBtnAnimation(false)}
              clickable={gameIsOn}
              onClick={() => {
                setBtnAnimation("submit");
                submit();
              }}
            >
              set
            </Button>
          </form>
          <Title>Previous seed pair</Title>
          {PreviousSeedPair.map((item, id) => (
            <Title key={id} copyCursor={item.Value === ""}>
              <h4>{item.Title}</h4>
              <textarea
                onClick={(e) => item.Value !== "" && copyToClipboard(e)}
                value={item.Value !== "" ? item.Value : item.Placeholder}
                spellCheck="false"
                readOnly="readOnly"
              />
            </Title>
          ))}
          <Button className={PreviousSeedPair[0].Value === undefined || PreviousSeedPair[0].Value === '' ? 'disabled':''}  onClick={() => VfCheck()}>Verify</Button>
          <Description>
            <h3>{ProvFairTitle.Title}</h3>
            <p>{ProvFairTitle.Description}</p>
          </Description>
          {ProvFairText.map((item, id) => (
            <Description key={id}>
              <h4>{item.Title}</h4>
              <p>{item.Description}</p>
            </Description>
          ))}
          <DetailedDescription />
        </OPBox>
      </OPWrapper>
    </OPContainer>
  );
};
